export const landingPage = {
  id: 'property-center-landingpage',
  name: _TL_('Landing Page'),
  route: 'propertycenter/landingpage',
};
